// extracted by mini-css-extract-plugin
export default {"inner":"ProfileIcon_inner__lJ8kw","head":"ProfileIcon_head__19ikL","body":"ProfileIcon_body__aZ+92"};